import feathers from '../feathers';
import type { User } from '../models/user';

/**
 * Service to handle user layout preference updates
 */
class UserLayoutService {
  private debounceTimer: NodeJS.Timeout | null = null;
  private readonly DEBOUNCE_DELAY = 500; // 500ms debounce

  /**
   * Update user's layout preferences in the database (debounced)
   */
  async updateUserLayoutPreferences(
    userId: string,
    preferences: User['layoutPreferences']
  ): Promise<void> {
    // Clear existing timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set new debounced timer
    return new Promise((resolve, reject) => {
      this.debounceTimer = setTimeout(async () => {
        try {
          // Update user in the database
          await feathers.service('users').patch(userId, {
            layoutPreferences: preferences,
          });

          console.log(`Updated user ${userId} layout preferences:`, preferences);
          resolve();
        } catch (error) {
          console.error('Failed to update user layout preferences:', error);
          reject(error);
        }
      }, this.DEBOUNCE_DELAY);
    });
  }

  /**
   * Get user's saved layout preferences
   */
  async getUserLayoutPreferences(
    userId: string
  ): Promise<User['layoutPreferences'] | null> {
    try {
      const user = await feathers.service('users').get(userId);
      return user.layoutPreferences || null;
    } catch (error) {
      console.error('Failed to get user layout preferences:', error);
      return null;
    }
  }

  /**
   * Cancel any pending debounced save
   */
  cancelPendingSave(): void {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }
}

export const userLayoutService = new UserLayoutService();


